module.exports = __webpack_public_path__ + "static/signup-improve-33b2142ec7aa9f2484c84f353414558c.png";